module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'vm-textarea' : 'vm-input',
      {
        'disabled': _vm.disabled,
      }
    ],
    style: (_vm.inputStyle)
  }, [(_vm.type !== 'textarea') ? [_vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "vm-input__icon",
    class: [
      _vm.icon,
      _vm.onIconClick ? 'clickable' : ''
    ],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', _vm._b({
    ref: "input",
    staticClass: "vm-input__inner",
    class: _vm.inputclass,
    style: (_vm.inputStyle),
    attrs: {
      "autocomplete": _vm.autoComplete
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleEnter($event)
      }
    }
  }, 'input', _vm.$props, false)) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "vm-textarea__inner",
    class: _vm.inputclass,
    style: (_vm.textareaStyle),
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, 'textarea', _vm.$props, false))], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27967e22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27967e22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input.vue
// module id = 20
// module chunks = 0